import React, { PureComponent } from "react";
import _ from "lodash";
import jstz from "jstz";
import moment from "moment-timezone";
import SweetAlert from "sweetalert-react";
import { Loader } from "react-loaders";
import { reactLocalStorage } from "reactjs-localstorage";
import { changeLocation } from "api/Location";
import "../node_modules/font-awesome/css/font-awesome.css";
import { browserHistory } from "react-router";

import "./styles";
import EventEmitter from "./services/event-emitter";
import WelcomePage from "./containers/welcome-page";
import LoginPage from "./containers/login-page";
import RegisterPage from "./containers/register-page";
import JoinPage from "./containers/join-page";
import ResetPasswordPage from "./containers/reset-password-page";
import AccountVerify from "./services/account-verify";
import ResetPassword from "./services/reset-password";
import PromoCodePage from "./containers/promo-code";
import TeamReportsLeftNavigation from "./components/team-reports/navigation/left";
import Auth from "./routes/Auth";
import { getRequest, batchRequest } from "./api/ApiService";
import { fetchAppGeneralInfo, clearAppGeneralInfoCache, pickCourseAndGame } from "./api/AppGeneralInfoService";
import {
  logError,
  getDateInCurrentTimezone,
  detectMobile
} from "./services/utils";
import TopBar from "./components/navigation/topbar";
import TeamProfilePage from "./components/team-profile-page";
import Teams from "./api/Teams";

import AutoLogout from "./auth/autologout";
import PaymentsPopup from "./components/payments/popup";
import LeftBar from "./components/navigation/leftbar";
import CoachingFeedback from "./components/coaching-feedback";
import StudentBadgesFlow from "./components/student-badges/StudentBadgesFlow";
import StudentResultsNotifications from "./components/student-notifications/StudentResultsNotifications";
import { resolveOnboardingEntry } from "./instructor/components/onboarding/onboardingRouting";

import Quiz from "./components/quiz/index";
import RoundProcessingPopup from "./components/round-processing";
import ContactSupport from "./components/contact-support";

import { view } from "@risingstack/react-easy-state";
import Analytics from "./services/analytics";
import AnalyticsSend from "./services/analytics-send";


import DecisionsAlert from "./components/alerts/decisions";

const TIMER_UPDATE_INTERVAL = 60000; // one minute in ms
const ROUND_HAS_ENDED_INTERVAL = 10000; // ten seconds in ms
const CHECK_ROUND_ENDED_INTERVAL = 10000; // one second in ms

const MIN_ROUNDS = 3; // show popup if count of rounds less than current value

class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      rounds: [],
      current_round: null,
      roundInUrl: null,
      team_color: "",
      tourMode: false,
      players: {},
      team_name: "",
      has_team_data: false,
      rounds_loaded: false,
      errorAlert: false,
      errorText: "",
      submitDecisionsAlert: false,
      submitDecisionsText: "",
      submitDecisionsType: "success",
      submitDecisionsSize: "md",
      isMobileMenuOpen: false,
      showPaymentsPopup: false,
      first_name: "",
      last_name: "",
      username: "",
      userPosition: "",
      coachingFeedbackTitle: null,
      coachingFeedbackMessage1: null,
      coachingFeedbackMessage2: null,
      coachingFeedbackMessage3: null,
      coachingFeedbackShow: false,
      roundShouldBeFinished: false,
      instructorRounds: [],
      instructorTeams: [],
      instructorCourses: [],
      instructorGames: [],
      instructorTeamplayers: [],
      courseMembers: [],
      sectionTeamsCount: 0,
      showPerformanceFeedbackAlert: false,
      isMenuExpanded: Auth.getMenuState(),
      isPerformanceFeedbackVisible: true,
      game: null,
      noGameYet: false,
      studentLockReason: null,
      // Student-only: fed from general-info.viewed_results. Drives
      // the Results-Ready notification popup.
      viewedResults: null,
      // Student-only: the current student's course_members row id,
      // derived from data.course_members by matching data.user.id.
      // Needed to PATCH rd<N>_viewed / <initial|final>_survey_viewed.
      courseMemberId: null,
    };

    this.eventemitter = EventEmitter.getInstance();
    this.need_to_cancel = false;
    this.isMobile = detectMobile();
  }

  setMenuState = isMenuExpanded => {
    this.setState({
      isMenuExpanded,
    }, () => {
      Auth.setMenuState(isMenuExpanded);
      this.eventemitter.trigger('activate-submenu');
    });
  }

  latestFinishedRound = rounds => {
    // Sort by round number ascending before picking the last element.
    // The BE returns rounds in insertion / id order, not number order,
    // so after Activate Main Rounds the array can land as (2, 3, 1)
    // and `finishedRounds[last]` would be Round 1 instead of the real
    // latest round — which would silently route users to the wrong
    // dashboard and feed the wrong round number into child components.
    const finishedRounds = rounds
      .filter(i => i.is_finished === true)
      .slice()
      .sort((a, b) => Number(a.number) - Number(b.number));

    return finishedRounds.length > 0
      ? finishedRounds[finishedRounds.length - 1]
      : null;
  };

  get latestFinishedRoundNumber() {
    const { rounds } = this.state;
    const latestFinishedRound = this.latestFinishedRound(rounds);

    return latestFinishedRound ? latestFinishedRound.number : 0;
  }

  showCoachingFeedback = (title, message1, message2, message3) => {
    this.setState(
      {
        coachingFeedbackTitle: title,
        coachingFeedbackMessage1: message1,
        coachingFeedbackMessage2: message2,
        coachingFeedbackMessage3: message3,
      },
      () => {
        this.setState({
          coachingFeedbackShow: true
        });
      }
    );
  };

  sendAnalyticsEvent = location => {
    if (this.state.current_round && Auth.getUserId()) {
      let activeRound = this.state.current_round.number;
      if (this.state.roundInUrl && this.state.roundInUrl !== "") {
        activeRound = this.state.roundInUrl;
      }

      if (
        /^\/ceo\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/pd\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/pm\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/op\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/fn\/analysis\/market.*$/.test(location.pathname) === true ||
        /^\/analysis\/bcase.*$/.test(location.pathname) === true ||
        /^\/analysis\/team-reports.*$/.test(location.pathname) === true
      ) {
        Analytics.event(activeRound, window, location.pathname);
      }
    }
  };

  componentDidMount() {
    this.unlisten = browserHistory.listen(this.sendAnalyticsEvent);

    this.fetchData();

    this.eventemitter.on("app-show-error", this.errorAlert);
    this.eventemitter.on("reload-data", this.fetchData);
    this.eventemitter.on("submit-decisions-event", this.submitDecisionsEvent);
    this.eventemitter.on("tour-enabled", this.enableTour);
    this.eventemitter.on("tour-disabled", this.disableTour);
    this.eventemitter.on("coaching-feedback", this.showCoachingFeedback);
    this.eventemitter.on("coaching-feedback-hide", this.coachingFeedbackOnClose);
    this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);

    if (typeof window !== "undefined") {
      window.addEventListener("click", this.handleLogout, false);
    }
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    this.detectRoundInUrl();

    // Instructor onboarding gate: back-button navigation (or any
    // other cross-app navigation) can otherwise land an instructor
    // on a non-onboarding page while the flow is incomplete. This
    // re-runs the routing rule on every location change and pushes
    // them back to whichever step they still owe. See
    // onboardingRouting.js for the rules.
    const prevPath = prevProps && prevProps.location && prevProps.location.pathname;
    if (
      Auth.getPosition() === 'Instructor'
      && prevPath !== location.pathname
      && location.pathname.indexOf('/instructor/onboarding') !== 0
      && location.pathname !== '/start'
      && location.pathname !== '/'
      && location.pathname !== '/login'
      && location.pathname !== '/register'
      && location.pathname !== '/promo-code'
      && location.pathname.indexOf('/reset-password') !== 0
      && location.pathname.indexOf('/verify') !== 0
    ) {
      resolveOnboardingEntry()
        .then(url => {
          if (url) changeLocation(url);
        })
        .catch(() => {});
    }

    if (this.isStudent === true) {
      // Skip the payment gate while the intro-video flow is still open.
      // Students with intro === 0 need to finish the video first; the
      // Stripe popup / promo-code redirect fires only after intro is 1.
      const user = Auth.getUser();
      const introPending = (user && user.intro === 0) || location.pathname === "/intro-video";
      if (introPending) return;

      if (Auth.isPaid() === false) {
        if (this.isMobile === true && location.pathname !== "/promo-code") {
          changeLocation("/promo-code");
        } else if (this.state.showPaymentsPopup !== true) {
          this.setState({
            showPaymentsPopup: true
          });
        }
      }
    }
  }

  componentWillUnmount() {
    this.unlisten();

    if (this.check_timer) {
      clearTimeout(this.check_timer);
      this.check_timer = null;
    }

    if (this.rounds_timer) {
      clearTimeout(this.rounds_timer);
      this.rounds_timer = null;
    }

    if (this.rounds_timer2) {
      clearTimeout(this.rounds_timer2);
      this.rounds_timer2 = null;
    }

    this.eventemitter.off("app-show-error", this.errorAlert);
    this.eventemitter.off("reload-data", this.fetchData);
    this.eventemitter.off("submit-decisions-event", this.submitDecisionsEvent);
    this.eventemitter.off("tour-enabled", this.enableTour);
    this.eventemitter.off("tour-disabled", this.disableTour);
    this.eventemitter.off("coaching-feedback", this.showCoachingFeedback);
    this.eventemitter.off("coaching-feedback-hide", this.coachingFeedbackOnClose);
    this.eventemitter.on("round-switcher-alert", this.showPerformanceFeedbackAlert);

    if (typeof window !== "undefined") {
      window.removeEventListener("click", this.handleLogout);
    }
  }

  showPerformanceFeedbackAlert = () => {
    this.setState({
      showPerformanceFeedbackAlert: true,
    });
  }

  hidePerformanceFeedbackAlert = () => {
    this.setState({
      showPerformanceFeedbackAlert: false,
    });
  }

  updateUserRoles = callback => {
    const joinRequest = batchRequest([
      ...Teams.requests(),
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/?game=${Auth.getGameId()}`
    ]);

    joinRequest
      .then(res => {
        const teams_data = [
          {
            status: res[0].statusCode,
            data: res[0].body
          },
          {
            status: res[1].statusCode,
            data: res[1].body
          }
        ];
        const teams_status = Teams.setData(teams_data);
        if (teams_status === "Error") {
          throw teams_status;
        }

        Auth.setPlayerRoles(res[2].body.results);

        if (callback) {
          callback();
        }
      })
      .catch(err => { });
  };

  fetchData = callback => {
    const { location } = this.props;
    const { showPaymentsPopup } = this.state;

    const queryToken = _.get(location, "query._token", null);
    const target = _.get(location, "query._target", null);
    const currentToken = Auth.getToken();

    if (queryToken && (!currentToken || target === "blank")) {
      Auth.setTemporaryUser({
        token: queryToken,
        game_id: _.get(location, "query.game_id", null),
        course_id: _.get(location, "query._courseid", null),
        user_id: _.get(location, "query._userid", null),
        team_id: _.get(location, "query.team_id", null),
      });
    }

    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      Auth.setToken(temporaryUser.token);
      Auth.setPosition("Instructor");
      Auth.setGameId(temporaryUser.game_id);
      Auth.setCourseId(temporaryUser.course_id);
      Auth.setUserId(temporaryUser.user_id);
      Auth.setTeamId(temporaryUser.team_id);

      changeLocation(`${location.pathname}?round=${_.get(location, 'query.round', null)}`);
    }

    const hasToken = Auth.getToken();
    if (!hasToken) {
      this.setState({
        showPaymentsPopup: false,
        loaded: true
      });
      this.detectRoundInUrl();
      return;
    }

    const isStudent = this.isStudent;
    const auth_game_id = Auth.getGameId();
    // Backend has two handlers gated on ?position=instructor|student.
    const general_info_position = isStudent ? "student" : "instructor";
    // Ask BE for the trimmed dashboard payload when the instructor is
    // actively on /instructor/dashboard. Other instructor pages
    // (round-admin, onboarding, welcome, etc.) call general-info
    // without the scope hint and keep receiving the full payload.
    const currentPath = (this.props.location && this.props.location.pathname) || "";
    const general_info_scope = (!isStudent && currentPath.indexOf("/instructor/dashboard") === 0)
      ? "dashboard"
      : undefined;

    // Fresh-session detector: Auth.deauthenticateUser clears
    // sessionStorage.game_id on logout, so an unset auth_game_id
    // signals we're starting over. Reset the one-shot refetch flag
    // so the "fire again with game_id" logic below can run for the
    // new session. Without this, the App instance persists across
    // logout/login in an SPA and the flag stays true forever after
    // the first successful refetch.
    if (!auth_game_id) {
      this._gi_refetched = false;
    }

    fetchAppGeneralInfo(auth_game_id, general_info_position, general_info_scope)
      .then(data => {
        const user = data.user;
        if (user) {
          if (JSON.stringify(user) !== JSON.stringify(Auth.getUser())) {
            Auth.setUserData(user);
          }

          const userData = {};
          if (user.first_name !== this.state.first_name) {
            userData.first_name = user.first_name;
          }
          if (user.last_name !== this.state.last_name) {
            userData.last_name = user.last_name;
          }
          if (user.username !== this.state.username) {
            userData.username = user.username;
          }
          if (user.role !== this.state.userPosition) {
            userData.userPosition = user.role;
          }
          if (user.id !== this.state.userId) {
            userData.userId = user.id;
          }

          if (Object.keys(userData).length > 0) {
            this.setState(userData);
          }
        }

        if (isStudent === true) {
          // Intro gate: first-time students must watch the ITB intro
          // video before any other student page renders (including the
          // Stripe payment popup). Return unconditionally when intro is
          // still 0 so downstream gates don't run over the top of it.
          if (user && user.intro === 0) {
            if (location.pathname !== "/intro-video") {
              changeLocation("/intro-video");
            }
            this.setState({ loaded: true });
            return;
          }

          if (Auth.isPaid() === false) {
            if (
              this.isMobile === true &&
              location.pathname !== "/promo-code"
            ) {
              changeLocation("/promo-code");
              this.setState({ loaded: true });
            } else if (showPaymentsPopup === false) {
              this.setState({ showPaymentsPopup: true, loaded: true });
            }
            return;
          }
        }

        // FE is authoritative on active course/game. Ignore data.game
        // singular; derive both from the arrays via the picker so the
        // choice is deterministic across login and general-info: highest-
        // id course, then highest-id game in that course. Prevents the
        // "highest-id game across all games" fallback from promoting a
        // foreign course's game.
        const { course: pickedCourse, game: pickedGame } = pickCourseAndGame(
          data.courses,
          data.games,
        );
        if (pickedCourse) {
          Auth.setCourseId(pickedCourse.id);
        }
        let game = pickedGame;

        // Student fallback: general-info's `data.games` isn't
        // always populated for students, so the picker can return
        // null even when the student is enrolled in a game. Use
        // `data.user.game` (authoritative for the logged-in user)
        // to source the game id in that case — either match against
        // data.games by id or synthesize a minimal { id } object so
        // the noGameYet lock doesn't fire incorrectly.
        if (isStudent && !game && data.user && data.user.game) {
          const userGameId = Number(data.user.game);
          const foundGame = (Array.isArray(data.games) ? data.games : [])
            .find(g => Number(g.id) === userGameId);
          // The student general-info payload uses `data.game`
          // (singular) — an object with round, rounds[], course, etc.
          // Prefer that over a synthesized {id} stub so downstream
          // logic (current_round derivation, Countdown, dropdown) has
          // the full game context.
          const singularGame = data.game && Number(data.game.id) === userGameId
            ? data.game
            : null;
          game = foundGame || singularGame || { id: userGameId };
        }

        // Additional student lock rule: even when a game exists,
        // the instructor may not have set an active round yet.
        // `data.user.game_round` is the authoritative signal — null
        // means no active round, so treat it the same as "no game"
        // and show the locked Welcome screen.
        //
        // Which lock message to show depends on whether the instructor
        // has scheduled any rounds yet:
        //   - Rounds exist but none is active → "Round Has Not Started
        //     Yet" (setup is done, just waiting for start).
        //   - No rounds scheduled at all      → same "Waiting on
        //     Instructor to set up exercise" message we use for the
        //     no-game case.
        let studentLockReason = null;
        if (isStudent && game) {
          const gameRound = data.user && data.user.game_round;
          if (gameRound == null) {
            const hasScheduledRounds = Array.isArray(data.rounds) && data.rounds.length > 0;
            studentLockReason = hasScheduledRounds ? 'round_not_started' : 'no_game';
            game = null;
          }
        }

        console.log('[MG:picker] general-info selection:', {
          pickedCourse,
          pickedGame,
          isStudent,
          userGame: data.user && data.user.game,
          resolvedGame: game,
          currentCourseId_after: Auth.getCourseId(),
        });
        const rounds = data.rounds || [];
        const teams = data.teams || [];
        const teamplayers = data.teamplayers || [];

        if (game) {
          Auth.setGameId(game.id);

          // On the very first login the sessionStorage game_id is
          // unset, so the general-info URL goes out as
          // `?position=<role>` with no game_id. The backend's
          // minimal response in that case only includes the user
          // object — no rounds, teams, teamplayers, or course_members.
          // Now that we know game.id (from either the picker or the
          // student fallback at line ~462), refire with it once — the
          // cache key changes so we get a fresh request that includes
          // the full payload. Guarded by `_gi_refetched` to prevent a
          // recursion loop if the backend still doesn't return the
          // extra fields.
          //
          // Signal of the minimal payload: rounds is empty. Fully set-up
          // games always ship rounds on both student and instructor
          // responses (including scope=dashboard), so an empty rounds
          // array means we got the stripped first-login payload and need
          // to refire with the resolved game_id. We previously used
          // `teamplayers.length === 0` for the instructor branch, but
          // scope=dashboard intentionally omits teamplayers now, which
          // falsely flagged every dashboard load as minimal and caused a
          // spurious second general-info request.
          const payloadLooksMinimal = rounds.length === 0;
          if (
            !this._gi_refetched
            && (!auth_game_id || payloadLooksMinimal)
            && game.id
          ) {
            this._gi_refetched = true;
            clearAppGeneralInfoCache();
            Auth.setGameId(game.id);
            this.fetchData(callback);
            return;
          }

          // Set teams data from consolidated response
          if (teams.length > 0 || teamplayers.length > 0) {
            const teams_data = [
              { status: 200, data: teamplayers },
              { status: 200, data: teams }
            ];
            Teams.setData(teams_data);
          }

          if (teamplayers.length > 0) {
            Auth.setPlayerRoles(teamplayers);
          }

          let players = {};
          Teams.players().forEach(player => {
            players[player.role] = {
              first_name: "user" in player ? player.user.first_name : "",
              last_name: "user" in player ? player.user.last_name : "",
              team_id: player.team
            };
          });

          const team = Teams.currentTeam();
          const team_color = Teams.currentTeamColor();
          const team_name = team ? team.name : "";

          const { round } = game;
          // The instructor-keyed general-info response may omit the
          // game.rounds id-list (the student response always includes
          // it). Fall back to all rounds whose `game` field matches —
          // they're already filtered to the current game by the
          // backend, so this is effectively a no-op for students.
          const gameRoundIds = Array.isArray(game.rounds) ? game.rounds : null;
          const current_rounds = gameRoundIds
            ? rounds.filter(i => gameRoundIds.includes(i.id))
            : rounds.filter(i => Number(i.game) === Number(game.id));

          let current_round = current_rounds.find(i => i.number === 1);
          if (round !== null) {
            current_round = current_rounds.find(i => i.id === round);
          }

          if (isStudent === true) {
            const hasRoundEnded = this.checkIfRoundHasEndedAndSetTimers(
              current_round,
              current_rounds
            );
            const interval = hasRoundEnded
              ? ROUND_HAS_ENDED_INTERVAL
              : TIMER_UPDATE_INTERVAL;

            setTimeout(this.updateRoundShouldBeFinished, 1000);

            if (this.rounds_timer) {
              clearTimeout(this.rounds_timer);
            }

            let updateTimer = true;

            const count_of_rounds = current_rounds.length;
            if (
              current_round &&
              count_of_rounds > 0 &&
              current_round.number ===
              current_rounds[count_of_rounds - 1].number &&
              hasRoundEnded === true
            ) {
              updateTimer = false;
            }

            if (this.need_to_cancel === true) {
              updateTimer = false;
              this.need_to_cancel = false;
            }

            // Only auto-refresh when user is on decision pages viewing the active round
            const isOnDecisionPage = window.location.pathname.includes('/decisions');
            const activeRoundNumber = current_round ? current_round.number : null;
            const viewingRound = Number(_.get(this.props, 'location.query.round', 0));
            const isViewingActiveRound = viewingRound === activeRoundNumber;

            if (updateTimer === true && isOnDecisionPage && isViewingActiveRound) {
              this.rounds_timer = setTimeout(this.fetchData, interval);
            }

            const roundData = {};
            if (JSON.stringify(players) !== JSON.stringify(this.state.players)) {
              roundData.players = players;
            }
            if (team_color !== this.state.team_color) {
              roundData.team_color = team_color;
            }
            if (team_name !== this.state.team_name) {
              roundData.team_name = team_name;
            }
            if (true !== this.state.has_team_data) {
              roundData.has_team_data = true;
            }
            if (true !== this.state.rounds_loaded) {
              roundData.rounds_loaded = true;
            }
            if (JSON.stringify(current_rounds) !== JSON.stringify(this.state.rounds)) {
              roundData.rounds = current_rounds;
            }
            if (JSON.stringify(current_round) !== JSON.stringify(this.state.current_round)) {
              roundData.current_round = current_round;
            }
            if (false !== this.state.showPaymentsPopup) {
              roundData.showPaymentsPopup = false;
            }
            if (true !== this.state.loaded) {
              roundData.loaded = true;
            }
            if (this.state.noGameYet) {
              roundData.noGameYet = false;
            }
            if (this.state.studentLockReason != null) {
              roundData.studentLockReason = null;
            }
            roundData.game = game;

            // Student-only: expose viewed_results (drives the
            // Results-Ready notification popup) and derive the
            // course_member id (needed to PATCH the viewed flags).
            // BE currently ships viewed_results inside data.user for
            // students but there's precedent for a top-level location;
            // accept either so we're robust to a BE relocation.
            const viewedResults =
              (data && data.viewed_results)
              || (data && data.user && data.user.viewed_results)
              || null;
            // Course-member id source order:
            //   1. data.course_members[] (instructor payload shape).
            //   2. data.teamplayers[].course_member for the self user
            //      (student payload shape — no top-level course_members).
            const selfUserId = Number(data.user && data.user.id);
            const courseMembers = (data && data.course_members) || [];
            const selfMember = courseMembers.find(
              cm => cm && Number(cm.user) === selfUserId
            );
            let courseMemberId = selfMember ? selfMember.id : null;
            if (!courseMemberId) {
              const selfPlayer = (Array.isArray(data.teamplayers) ? data.teamplayers : [])
                .find(tp => tp && tp.user && Number(tp.user.id) === selfUserId);
              if (selfPlayer && selfPlayer.course_member) {
                courseMemberId = selfPlayer.course_member;
              }
            }
            if (JSON.stringify(viewedResults) !== JSON.stringify(this.state.viewedResults)) {
              roundData.viewedResults = viewedResults;
            }
            if (courseMemberId !== this.state.courseMemberId) {
              roundData.courseMemberId = courseMemberId;
            }

            if (Object.keys(roundData).length > 0) {
              this.setState(roundData, () => {
                this.sendAnalyticsEvent(this.props.location);
                if (callback) callback();
              });
            } else {
              this.sendAnalyticsEvent(this.props.location);
              if (callback) callback();
            }
          } else {
            // Instructor with team
            const instructorRounds = current_rounds.filter(i => Number(i.game) === Number(game.id));

            this.setState(
              {
                game,
                players,
                team_color,
                team_name,
                has_team_data: true,
                rounds_loaded: true,
                rounds: instructorRounds,
                instructorRounds,
                instructorTeams: teams,
                instructorCourses: data.courses || [],
                instructorGames: data.games || [],
                instructorTeamplayers: teamplayers,
                courseMembers: data.course_members || [],
                sectionTeamsCount: Number(data.section_teams_count) || 0,
                current_round,
                roundInUrl: _.get(location, 'query.round', null),
                showPaymentsPopup: false,
                loaded: true
              },
              () => {
                if (callback) callback();
              }
            );
          }
        } else {
          // No game for the picked course. Two flows:
          //   Student: redirect to /onboarding (Welcome) and render
          //   the locked "Waiting on Instructor" screen. The intro
          //   video and is_paid gates above still run first.
          //   Instructor: unchanged — falls through to the existing
          //   partial-onboarding path (create game via SimulationSelection).
          if (isStudent === true) {
            if (location.pathname !== "/onboarding") {
              changeLocation("/onboarding");
            }
            this.setState({
              game: null,
              current_round: null,
              rounds: [],
              noGameYet: true,
              // Default to 'no_game' when studentLockReason wasn't set
              // upstream (i.e. the picker never resolved a game to begin
              // with). The 'round_not_started' variant is only set when
              // a game DID resolve but no round is active yet AND rounds
              // are already scheduled.
              studentLockReason: studentLockReason || 'no_game',
              showPaymentsPopup: false,
              loaded: true,
            }, () => {
              if (callback) callback();
            });
          } else {
            this.setState({
              game: null,
              current_round: null,
              rounds: [],
              instructorRounds: [],
              instructorCourses: data.courses || [],
              instructorGames: data.games || [],
              instructorTeamplayers: teamplayers,
              courseMembers: data.course_members || [],
              sectionTeamsCount: Number(data.section_teams_count) || 0,
              roundInUrl: _.get(location, 'query.round', null),
              showPaymentsPopup: false,
              loaded: true,
            }, () => {
              if (callback) callback();
            });
          }
        }
      })
      .catch(err => {
        logError(err, "App", "fetchData");
      });

    this.detectRoundInUrl();
  };

  getNumber = str => {
    let val = parseInt(str, 10);
    if (isNaN(val)) {
      return 0;
    }

    return val;
  };

  needRedirect = current_round => {
    const isTimesUpShown =
      reactLocalStorage.get("timesUpModal", "false") === "true";
    const timesUpInfo = reactLocalStorage
      .get("timesUpModalRound", "0::0::0::0")
      .split("::");
    const game_id = this.getNumber(timesUpInfo[0]);
    const user_id = this.getNumber(timesUpInfo[1]);
    const round_number = this.getNumber(timesUpInfo[2]);
    const round_id = this.getNumber(timesUpInfo[3]);
    const original_user_id = this.getNumber(Auth.getUserId());
    const original_game_id = this.getNumber(Auth.getGameId());

    return (
      isTimesUpShown === false ||
      round_number !== current_round.number ||
      round_id !== current_round.id ||
      user_id !== original_user_id ||
      game_id !== original_game_id
    );
  };

  goToDashboard = round => {
    const game_id = this.getNumber(Auth.getGameId());
    const user_id = this.getNumber(Auth.getUserId());

    const hash = `${game_id}::${user_id}::${round.number}::${round.id}`;

    this.eventemitter.trigger("disable-team-feedback");
    reactLocalStorage.set("timesUpModal", true);
    reactLocalStorage.set("timesUpModalRound", hash);
    this.rounds_timer2 = setTimeout(() => {
      this.fetchData(() => {
        this.updateUserRoles(() => {
          this.eventemitter.trigger("reload-data");
        });
      });
    }, 3000);
    changeLocation(`/start`);
  };

  checkForRedirect = rounds => {
    const latestFinishedRound = this.latestFinishedRound(rounds);
    if (
      latestFinishedRound &&
      this.needRedirect(latestFinishedRound) === true &&
      window.location.pathname !== "/get-started"
    ) {
      this.goToDashboard(latestFinishedRound);
      return true;
    }

    return false;
  };

  checkIfRoundHasEndedAndSetTimers(current_round, current_rounds) {
    if (Auth.isUserAuthenticated() === false) {
      return;
    }

    if (this.check_timer) {
      clearTimeout(this.check_timer);
      this.check_timer = null;
    }

    if (current_round) {
      const need_redirect = this.checkForRedirect(current_rounds);

      if (need_redirect === true) {
        if (this.rounds_timer) {
          clearTimeout(this.rounds_timer);
          this.rounds_timer = null;
        }

        this.need_to_cancel = true;

        return false;
      } else {
        const end_date = getDateInCurrentTimezone(
          moment(current_round.end_date)
        );
        const now_date = getDateInCurrentTimezone(moment());
        const time = end_date - now_date;

        let round_has_ended = false;

        if (
          time <= 0 &&
          current_round.is_finished !== true &&
          this.state.current_round
        ) {
          if (this.rounds_timer) {
            clearTimeout(this.rounds_timer);
            this.rounds_timer = null;
          }

          this.need_to_cancel = true;

          round_has_ended = true;
          this.setRoundProcessing(() => {
            this.rounds_timer2 = setTimeout(() => {
              this.fetchData();
            }, ROUND_HAS_ENDED_INTERVAL);
          });
        } else if (current_round.is_finished === true) {
          round_has_ended = true;
        } else {
          this.check_timer = setTimeout(() => {
            this.checkIfRoundHasEndedAndSetTimers(
              current_round,
              current_rounds
            );
          }, CHECK_ROUND_ENDED_INTERVAL);
        }

        return round_has_ended;
      }
    }

    return false;
  }

  get isStudent() {
    return Auth.getPosition() === "Student" ? true : false;
  }

  detectRoundInUrl = () => {
    const { location } = this.props;
    let roundInUrl = null;

    if (location.query.round) {
      roundInUrl = parseInt(location.query.round, 10);

      if (isNaN(roundInUrl)) {
        roundInUrl = null;
      }
    }

    if (roundInUrl !== this.state.roundInUrl) {
      this.setState(
        {
          roundInUrl
        },
        () => {


        }
      );
    }
  };

  get currentRound() {
    const { current_round } = this.state;

    if (!current_round) {
      return 1;
    }

    return current_round.number;
  }

  updateRoundShouldBeFinished = () => {
    const { current_round } = this.state;
    let result = false;

    if (current_round) {
      const end_date = getDateInCurrentTimezone(moment(current_round.end_date));
      const now_date = getDateInCurrentTimezone(moment());

      if (now_date > end_date) {
        result = true;
      }
    }

    if (this.state.roundShouldBeFinished !== result) {
      this.setState(
        {
          roundShouldBeFinished: result
        },
        () => {
          setTimeout(this.updateRoundShouldBeFinished, 1000);
        }
      );
    } else {
      setTimeout(this.updateRoundShouldBeFinished, 1000);
    }
  };

  setRoundProcessing = callback => {
    let current_round = _.cloneDeep(this.state.current_round);
    current_round.should_be_finished = true;

    this.setState(
      {
        current_round
      },
      () => {
        callback();
      }
    );
  };

  errorAlert = errorText => {
    this.setState(
      {
        errorText
      },
      () => {
        this.showErrorAlert();
      }
    );
  };

  showErrorAlert = () => {
    this.setState({
      errorAlert: true
    });
  };

  hideErrorAlert = () => {
    this.setState({
      errorAlert: false
    });
  };

  hideSubmitDecisionsAlert = () => {
    this.setState({
      submitDecisionsAlert: false
    });
  };

  showSubmitDecisionsAlert = () => {
    this.setState({
      submitDecisionsAlert: true
    });
  };

  submitDecisionsEvent = (type, text, size) => {
    this.setState(
      {
        submitDecisionsType: type,
        submitDecisionsText: text,
        submitDecisionsSize: size || "md"
      },
      () => {
        this.showSubmitDecisionsAlert();
      }
    );
  };

  enableTour = () => {
    this.setState({
      tourMode: true
    });
  };

  disableTour = () => {
    this.setState({
      tourMode: false
    });
  };

  get isRoundsEmpty() {
    const { rounds, rounds_loaded } = this.state;

    return rounds_loaded === true && rounds.length < MIN_ROUNDS;
  }

  get isRound1NotStarted() {
    const { current_round, rounds_loaded } = this.state;
    const game_id = Auth.getGameId();

    return (
      (this.isRoundsEmpty === false &&
        current_round &&
        current_round.is_started === false &&
        this.rolesIsEmpty === false &&
        current_round.number === 1 &&
        rounds_loaded === true) ||
      (this.isRoundsEmpty === false &&
        this.rolesIsEmpty === false &&
        game_id === 0 &&
        rounds_loaded === true)
    );
  }

  get isRoundsLoaded() {
    const { rounds_loaded } = this.state;

    return (
      this.isRoundsEmpty === false &&
      rounds_loaded === true &&
      this.isRound1NotStarted === false
    );
  }

  get rolesIsEmpty() {
    const role = Auth.getRole();

    if (
      role !== "CEO" &&
      role !== "PD" &&
      role !== "PM" &&
      role !== "OP" &&
      role !== "FI" &&
      role !== "VI"
    ) {
      return true;
    }

    return false;
  }

  get isRoundProcessing() {
    const { current_round, roundShouldBeFinished } = this.state;
    const game_id = Auth.getGameId();

    return (
      roundShouldBeFinished === true &&
      current_round &&
      current_round.is_finished === false &&
      game_id !== 0
    );
  }

  get round1StartText() {
    const { current_round } = this.state;

    if (!current_round) {
      return "";
    }

    const timezone = jstz.determine();
    let startDate = moment(current_round.start_date)
      .tz(timezone.name())
      .format("MM/DD/YYYY hh:mmA");
    return `Round 1 starts ${startDate}`;
  }

  logout = () => {
    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
      window.location.reload();
    }
  };

  handleLogout = e => {
    const element = e.target;

    if (
      element.tagName === "A" &&
      element.classList.contains("sweetalert-logout-button")
    ) {
      e.preventDefault();
      this.logout();
    }
  };

  get activeRound() {
    const { roundInUrl } = this.state;
    const currentRound = this.currentRound;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return roundInUrl;
    }

    return currentRound;
  }

  closeMobileMenu = () => {
    if (this.isMobile) {
      this.setState({
        isMobileMenuOpen: false
      });
    }
  };

  handleMobileMenuState = state => {
    this.setState({
      isMobileMenuOpen: state.isOpen
    });
  };

  coachingFeedbackOnClose = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      coachingFeedbackShow: false
    });
  };

  render() {
    const {
      loaded,
      rounds,
      roundInUrl,
      team_color,
      tourMode,
      errorAlert,
      errorText,
      submitDecisionsAlert,
      submitDecisionsText,
      submitDecisionsType,
      submitDecisionsSize,
      showPaymentsPopup,
      coachingFeedbackShow,
      coachingFeedbackTitle,
      coachingFeedbackMessage1,
      coachingFeedbackMessage2,
      coachingFeedbackMessage3,
      first_name,
      last_name,
      instructorRounds,
      roundShouldBeFinished,
      username,
      showPerformanceFeedbackAlert,
      instructorTeams,
      instructorCourses,
      instructorGames,
      instructorTeamplayers,
      courseMembers,
      sectionTeamsCount,
      isMenuExpanded,
      isPerformanceFeedbackVisible,
      game,
      noGameYet,
      studentLockReason,
    } = this.state;

    const currentRound = this.currentRound;
    const { location, children, params } = this.props;
    const isStudent = this.isStudent;
    const latestFinishedRoundNumber = this.latestFinishedRoundNumber;
    const appWrapperClassName =
      location.pathname === "/team-reports"
        ? "app-wrapper team-reports-wrapper"
        : "app-wrapper";

    // Recompute team_color on every render instead of trusting the
    // cached state value. The cached value was set from Teams.
    // currentTeamColor() at fetchData time; if a later flow (e.g.
    // Analysis.js writing competition-scoped teams_data) changes the
    // underlying map, the cache goes stale and the topbar avatar
    // disagrees with the charts. Reading through Teams.currentTeamColor
    // every render keeps the topbar in sync with the same localStorage
    // teams_data the charts read from.
    const liveTeamColor = Teams.currentTeamColor() || team_color;

    if (loaded === false) {
      return (
        <div className="application-loading">
          <Loader type="ball-scale-ripple" active />
        </div>
      );
    }
    if (location.pathname === "/login") {
      return <LoginPage location={location} />;
    }

    if (location.pathname === "/welcome") {
      return <WelcomePage />;
    }

    if (location.pathname === "/register") {
      return <RegisterPage />;
    }

    if (location.pathname === "/join") {
      return <JoinPage />;
    }

    if (location.pathname === "/reset-password") {
      return <ResetPasswordPage />;
    }

    if (location.pathname === "/forms") {
      return <Quiz userId={this.state.userId} />;
    }

    if (location.pathname === "/promo-code") {
      return <PromoCodePage />;
    }

    const pathes = location.pathname.split("/").filter(i => i !== "");
    if (pathes.length === 2 && pathes[0] === "verify") {
      const { token } = params;
      return <AccountVerify token={token} />;
    }

    if (pathes.length === 3 && pathes[0] === "reset-password") {
      const { token1, token2 } = params;
      return <ResetPassword token1={token1} token2={token2} />;
    }

    // Full-screen takeovers with no app chrome (no leftbar, no
    // dashboard header). Instructor first-login onboarding is a
    // guided flow that owns the entire viewport; /demo is the
    // placeholder landing for the Demo path.
    if (
      location.pathname.indexOf('/instructor/onboarding') === 0 ||
      location.pathname === '/demo'
    ) {
      return children;
    }

    const fullname = `${first_name} ${last_name}`;

    return (
      <div id="outer-container">
        {/* Contact Support popup + floating (?) button. Mounted at the
            outer-container level so it appears for both students and
            instructors on every authenticated page (all unauthenticated
            surfaces return early above). Opens either from the FAB or
            from "Contact Support" in the header user menu (dispatched
            via EventEmitter). */}
        <ContactSupport />
        {isStudent === true && (
          <div>
            <SweetAlert
              show={this.isRound1NotStarted}
              title="Round 1 has not started yet!"
              text={this.round1StartText}
              confirmButtonText="Logout"
              onConfirm={this.logout}
            />
            <SweetAlert
              show={this.rolesIsEmpty}
              type="warning"
              title="Warning"
              text="This user has not any role. Please add specific role for this user."
              confirmButtonText="Logout"
              onConfirm={this.logout}
            />
            <RoundProcessingPopup
              isRoundProcessing={this.isRoundProcessing}
              round={this.state.current_round}
              courseMemberId={this.state.courseMemberId}
              viewedResults={this.state.viewedResults}
            />
          </div>
        )}
        <SweetAlert
          show={errorAlert}
          title="Warning"
          text={errorText}
          type="warning"
          onConfirm={this.hideErrorAlert}
        />
        {submitDecisionsAlert && <DecisionsAlert
          title={
            submitDecisionsType === "success"
              ? "Submission Successful"
              : submitDecisionsType === "warning"
                ? "Submission Successful"
                : submitDecisionsType === "info"
                  ? "Heads Up!"
                  : "Submission Failed"
          }
          message={submitDecisionsText}
          type={submitDecisionsType}
          size={submitDecisionsSize}
          onHide={this.hideSubmitDecisionsAlert}
        />}
        <SweetAlert
          show={showPerformanceFeedbackAlert}
          title="Warning"
          text="You'll need to review your performance feedback before you will be able to navigate to the next round."
          type="warning"
          onConfirm={this.hidePerformanceFeedbackAlert}
        />
        <CoachingFeedback
          team_color={liveTeamColor}
          title={coachingFeedbackTitle}
          message1={coachingFeedbackMessage1}
          message2={coachingFeedbackMessage2}
          message3={coachingFeedbackMessage3}
          onClose={this.coachingFeedbackOnClose}
          show={coachingFeedbackShow}
        />

        <div className="flex">
          {
            <TopBar
              isStudent={isStudent}
              team_color={liveTeamColor}
              location={location}
              currentRound={currentRound}
              roundInUrl={roundInUrl}
              rounds={rounds}
              latestFinishedRoundNumber={latestFinishedRoundNumber}
              isMobile={this.isMobile}
              activeRound={this.activeRound}
              name={isStudent ? fullname : (last_name ? `Professor ${last_name}` : username)}
              position={this.state.userPosition}
              instructorTeams={instructorTeams}
              isMenuExpanded={isMenuExpanded}
              setMenuState={this.setMenuState}
            />
          }
          <div id="app-wrapper" className={appWrapperClassName}>
            <LeftBar
              latestFinishedRoundNumber={latestFinishedRoundNumber}
              isStarted={this.isRound1NotStarted}
              years={{ data: rounds }}
              rounds={rounds}
              currentRound={currentRound}
              roundInUrl={roundInUrl}
              gameRound={this.state.game ? this.state.game.round : undefined}
              location={location}
              isStudent={isStudent}
              isRoundsLoaded={this.isRoundsLoaded}
              closeMobileMenu={this.closeMobileMenu}
              isMobile={this.isMobile}
              activeRound={this.activeRound}
              team_name={this.state.team_name}
              position={this.state.userPosition}
              instructorRounds={instructorRounds}
              isMenuExpanded={isMenuExpanded}
              isPerformanceFeedbackVisible={isPerformanceFeedbackVisible}
              noGameYet={noGameYet}
            />
            {location.pathname === "/team-reports" &&
              this.isMobile === false && <TeamReportsLeftNavigation />}
            {isStudent === true &&
              React.Children.map(children, child =>
                React.cloneElement(child, {
                  rounds,
                  rounds_loaded: this.state.rounds_loaded,
                  // Raw `game.round` field from the backend. Null after a
                  // game reset (before rounds are provisioned). We can't
                  // use `current_round` here because App falls back to
                  // "round with number=1" when game.round is null (see
                  // ~line 478), which masks the reset state. Consumers
                  // gate on `gameRound == null` to lock decision pages.
                  gameRound: this.state.game ? this.state.game.round : undefined,
                  currentRound,
                  roundInUrl,
                  team_color: liveTeamColor,
                  tourMode,
                  roundShouldBeFinished,
                  noGameYet,
                  studentLockReason,
                })
              )}
            {isStudent === false &&
              React.Children.map(children, child =>
                React.cloneElement(child, {
                  rounds: instructorRounds,
                  currentRound,
                  roundInUrl,
                  isMenuExpanded,
                  game,
                  teams: instructorTeams,
                  courses: instructorCourses,
                  games: instructorGames,
                  teamplayers: instructorTeamplayers,
                  courseMembers,
                  sectionTeamsCount,
                })
              )}
            {isStudent === true && <TeamProfilePage />}
            {/* Student badges intro popup + consent tour. Renders
                globally for students who have a pending Skills Badge.
                Skipped in the locked/noGameYet state (no badges
                exist for a student whose game hasn't been set up)
                and while the intro / payment gates are still open. */}
            {isStudent === true
              && !noGameYet
              && !showPaymentsPopup
              && <StudentBadgesFlow />}
            {/* Results-Ready notification: appears on student login when
                an un-viewed round or peer-eval has closed. Same gates as
                the Skills Badge popup (no locked/payment states).
                See StudentResultsNotifications.js for the priority
                rules. */}
            {isStudent === true
              && !noGameYet
              && !showPaymentsPopup
              && this.state.viewedResults
              && this.state.courseMemberId
              && (
                <StudentResultsNotifications
                  viewedResults={this.state.viewedResults}
                  courseMemberId={this.state.courseMemberId}
                  currentRound={currentRound}
                  rounds={this.state.rounds}
                  suppress={this.isRoundProcessing}
                />
              )}
            {isStudent === true && (
              showPaymentsPopup === true ||
              (pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success') ||
              (pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel')
            ) && (
                <PaymentsPopup
                  isSuccess={pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'success'}
                  isCancel={pathes.length === 2 && pathes[0] === 'checkout' && pathes[1] === 'cancel'}
                />
              )}
          </div>
          {location.pathname !== "/team-reports"}
        </div>
        <AutoLogout />
        <AnalyticsSend />
      </div>
    );
  }
}

export default view(App);



// WEBPACK FOOTER //
// ./src/App.js